// customer (CRM) request schemas — worker validates, SPA reuses. every field is optional/
// defaulted so partial forms are accepted; a create/update must carry at least one identity
// field (name / company / email) so we never persist a blank record.
import { z } from 'zod';
import { CUSTOMER_TYPES } from '../domain/customer.js';
const s = (max) => z.string().max(max).optional().default('');
export const CustomerFieldsSchema = z.object({
    customerType: z.enum(CUSTOMER_TYPES).optional().default('individual'),
    firstName: s(120),
    lastName: s(120),
    companyName: s(200),
    registeredAddress: s(400),
    street: s(200),
    postalCode: s(40),
    city: s(120),
    country: s(120),
    vatNumber: s(80),
    taxCode: s(80),
    profession: s(120),
    email: z.string().max(200).optional().default(''),
    telephone: s(60),
    mobile: s(60),
    dealer: s(160),
    notes: s(2000),
});
const hasIdentity = (o) => !!(o.companyName.trim() || o.firstName.trim() || o.lastName.trim() || o.email.trim());
const identityMsg = { message: 'Provide a name, company, or email' };
export const CustomerCreateSchema = CustomerFieldsSchema.refine(hasIdentity, identityMsg);
export const CustomerUpdateSchema = CustomerFieldsSchema.extend({
    id: z.number().int().positive(),
}).refine(hasIdentity, identityMsg);
export const CustomerIdSchema = z.object({ id: z.number().int().positive() });
// merge: fold one or more duplicate records into a primary. `resolved` = the final field values
// the primary keeps (the UI picks per conflicting field). acknowledgeConflict must be true to
// proceed when strong identifiers conflict (VAT / tax / country / individual-vs-company).
export const MergeCustomersSchema = z
    .object({
    primaryId: z.number().int().positive(),
    mergedIds: z.array(z.number().int().positive()).min(1).max(20),
    resolved: CustomerFieldsSchema,
    reason: z.string().max(1000).optional().default(''),
    acknowledgeConflict: z.boolean().optional().default(false),
})
    .refine((o) => !o.mergedIds.includes(o.primaryId), { message: 'Primary cannot be in the merged list', path: ['mergedIds'] });
export const UnmergeSchema = z.object({ eventId: z.number().int().positive() });
export const CustomerSearchSchema = z.object({
    q: z.string().max(160).optional().default(''),
    limit: z.number().int().min(1).max(50).optional().default(20),
});
//# sourceMappingURL=customers.js.map